<template>
  <div>
    <v-combobox
      v-model="values"
      :items="items"
      outlined
      dense
      chips
      small-chips
      label="Affiliations"
      multiple
      @change="emitAffiliationsChanged()"
    ></v-combobox>
  </div>
</template>

<script>
export default {
  name: "Affiliations",
  data() {
    return {
      values: [],
      items: [
        "Arizona State University",
        "Auburn University",
        "Binghamton University",
        "Boston College",
        "Boston University",
        "Brandeis University",
        "Brown University",
        "California Institute of Technology",
        "Carnegie Mellon University",
        "Case Western Reserve University",
        "Clemson University",
        "Colorado State University",
        "Columbia University in the City of New York",
        "Cornell University",
        "CUNY Graduate School and University Center",
        "Dartmouth College",
        "Drexel University",
        "Duke University",
        "Emory University",
        "Florida International University",
        "Florida State University",
        "George Mason University",
        "George Washington University",
        "Georgetown University",
        "Georgia Institute of Technology",
        "Georgia State University",
        "Harvard University",
        "Indiana University Bloomington",
        "Iowa State University",
        "Johns Hopkins University",
        "Kansas State University",
        "Louisiana State University and Agricultural & Mechanical College",
        "Massachusetts Institute of Technology",
        "Michigan State University",
        "Mississippi State University",
        "Montana State University",
        "New Jersey Institute of Technology",
        "New York University",
        "North Carolina State University",
        "Northeastern University",
        "Northwestern University",
        "Oklahoma State University",
        "Oregon State University",
        "Pennsylvania State University",
        "Princeton University",
        "Purdue University",
        "Rensselaer Polytechnic Institute",
        "Rice University",
        "Rutgers University–New Brunswick",
        "Stanford University",
        "Stony Brook University",
        "SUNY at Albany",
        "Syracuse University",
        "Temple University",
        "Texas A&M University",
        "Texas Tech University",
        "The Ohio State University",
        "The University of Alabama",
        "The University of Tennessee",
        "The University of Texas at Austin",
        "The University of Texas at Arlington",
        "The University of Texas at Dallas",
        "The University of Texas at El Paso",
        "Tufts University",
        "Tulane University of Louisiana",
        "University at Buffalo",
        "University of Alabama at Birmingham",
        "University of Arizona",
        "University of Arkansas",
        "University of California, Berkeley",
        "University of California, Davis",
        "University of California, Irvine",
        "University of California, Los Angeles",
        "University of California, Riverside",
        "University of California, San Diego",
        "University of California, Santa Barbara",
        "University of California, Santa Cruz",
        "University of Central Florida",
        "University of Chicago",
        "University of Cincinnati",
        "University of Colorado Boulder",
        "University of Colorado Denver/Anschutz-Medical Campus",
        "University of Connecticut",
        "University of Delaware",
        "University of Florida",
        "University of Georgia",
        "University of Hawaii at Manoa",
        "University of Houston",
        "University of Illinois at Chicago",
        "University of Illinois at Urbana–Champaign",
        "University of Iowa",
        "University of Kansas",
        "University of Kentucky",
        "University of Louisville",
        "University of Maryland, College Park",
        "University of Massachusetts Amherst",
        "University of Miami",
        "University of Michigan",
        "University of Minnesota",
        "University of Mississippi",
        "University of Missouri",
        "University of Nebraska–Lincoln",
        "University of Nevada, Las Vegas",
        "University of Nevada, Reno",
        "University of New Hampshire",
        "University of New Mexico",
        "University of North Carolina at Chapel Hill",
        "University of North Texas",
        "University of Notre Dame",
        "University of Oklahoma",
        "University of Oregon",
        "University of Pennsylvania",
        "University of Pittsburgh",
        "University of Rochester",
        "University of South Carolina",
        "University of South Florida",
        "University of Southern California",
        "University of Southern Mississippi",
        "University of Utah",
        "University of Virginia",
        "University of Washington	Public",
        "University of Wisconsin–Madison",
        "University of Wisconsin–Milwaukee",
        "Vanderbilt University",
        "Virginia Commonwealth University",
        "Virginia Polytechnic Institute and State University",
        "Washington State University",
        "Washington University in St. Louis",
        "Wayne State University",
        "West Virginia University",
        "Yale University"
      ]
    };
  },
  methods: {
    clearValues() {
      this.values = [];
    },
    emitAffiliationsChanged() {
      this.$emit("tags-changed", this.values);
    }
  }
};
</script>

<style lang="scss" scoped></style>
